/// <amd-module name="Analytics/Shared/Utils/DateUtils" />

export function getDate(): Date {
    return new Date();
}

export function shiftToUTC(date: Date): Date {
    return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    );
}

/**
 * Adds days to a given date
 *
 * @param date The Date object to add to
 * @param days Number of days to add
 * @param adjustOffset is true then the offset will be adjusted if the offset between the date passed
 * and the date obtained after adding days is different.
 *
 */
export function addDays(date: Date, days: number, adjustOffset: boolean = false): Date {
    let newDate = getDate(); // Explicit cast here because of Date declare override at top of file.
    newDate.setTime(date.getTime() + days * 86400000);
    if (adjustOffset) {
        newDate = adjustOffsetForTimes(date, newDate);
    }

    return newDate;
}

/**
 * Adjusts the time zone offset by applying the time difference in the offsets.
 *
 * @param oldDate The Date object which was used before time zone changed.
 * @param newDate The Date object which was used after time zone changed.
 */
export function adjustOffsetForTimes(oldDate: Date, newDate: Date, applicationDate?: Date): Date {
    // this function should be used if the offset between the old date and new date is different
    // and their difference is to be applied to the applied date passed in.
    // for eg. if the oldDate is March 11 00:00 AM 7GMT and the newDate is March 9 23:00 PM 8GMT
    // then there is a offset difference of 1 hour. This will happen when you use addDays(oldDate, -1)
    // because of the offset difference the result you will get March 9 23:00 PM 8GMT instead of March 10 00:00 AM 8GMT
    // hence the offset is applied to March 9 23:00 PM to get March 10 00:00 AM 8GMT

    let setDate = newDate;

    if (applicationDate != null) {
        setDate = applicationDate;
    }

    const oldOffset = oldDate.getTimezoneOffset();
    const newOffset = newDate.getTimezoneOffset();
    if (oldOffset !== newOffset) {
        setDate = addDays(setDate, (newOffset - oldOffset) / (60 * 24));
    }

    return setDate;
}

// TODO: Remove after Rakesh's PR completes, use from Common/Utils/DateSKParser
export function convertDateToDateString(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    const array = [year, month <= 9 ? "0" + month : month, day <= 9 ? "0" + day : day];
    return array.join("-");
}
